const isJapanese = (language) =>
  typeof language === "string" && language.toLowerCase().startsWith("ja");

const normalizePreferenceValues = (preference) => {
  if (Array.isArray(preference)) {
    return preference
      .map((value) => String(value || "").trim())
      .filter(Boolean);
  }

  const singleValue = String(preference || "").trim();
  return singleValue ? [singleValue] : [];
};

export const getCriteriaSelectionLines = ({ criteriaSet, language }) => {
  if (!Array.isArray(criteriaSet)) return [];

  const useJapanese = isJapanese(language);

  return criteriaSet
    .map((item) => {
      if (!item || typeof item !== "object") return "";

      const topic = String(
        (useJapanese ? item.topic_ja : item.topic) ||
          item.topic ||
          item.topic_ja ||
          "",
      ).trim();
      const preferences = normalizePreferenceValues(item.preference);
      if (preferences.length === 0) return "";

      return topic
        ? `${topic}: ${preferences.join(", ")}`
        : preferences.join(", ");
    })
    .filter(Boolean);
};

export const getCriteriaSelectionText = ({ criteriaSet, language }) =>
  getCriteriaSelectionLines({ criteriaSet, language }).join(" | ");
